<div class="modal show" id="votesModal" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Sponsors</h5>
        <button type="button" class="close" data-dismiss="modal" (click)="close()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <span>{{getSponsors()}}</span>
        <br>
        <table>
          <tr><td>Total</td><td>{{sponsorCount}}</td></tr>
          </table>
      </div>
      <div class="modal-footer">
        <button type="button" (click)="close()">
          &times; Close</button>
      </div>
    </div>
  </div>
</div>
<div class="modal-backdrop fade show" id="backdrop" style="display: none;"></div>
